export const messengerUrl = "https://m.me/amarpetcom";
